import React, { useContext } from 'react';
import { LanguageContext } from '../../utils/LanguageContext';

import './style.css';

const Contact = () => {
  const { language, changeLanguage, translations } =
    useContext(LanguageContext);

  return (
    <div className="container">
      <h2 className="page-title">{translations[language].contact}</h2>
      <div className="content-container">
        <div className="text-content">{translations[language].contact_copy}</div>
      </div>
    </div>
  );
};

export default Contact;
